import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      this.element.classList.add("transition-all", "duration-300")
      this.element.classList.remove("opacity-0", "-translate-y-4")
    })
  }
}

